export default "__VITE_ASSET__Bu6EAPX0__"